<template>
  <ListeTypeRecette />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeTypeRecette from "@/components/Parametres/ListeTypeRecette.vue";

export default defineComponent({
  name: "ListeTypeRecettePage",
  components: {
    ListeTypeRecette,
  },
});
</script>

